"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QuickSuggestionsOption_1 = require("owa-quick-suggestions-option/lib/QuickSuggestionsOption");
var LinkPreviewOption_1 = require("owa-link-preview-option/lib/LinkPreviewOption");
var MessageFormatOption_1 = require("owa-message-format-option/lib/MessageFormatOption");
var messageContentSubcategory = {
    key: 'messageContent',
    titleStringKey: 'optionSubcategory_messageContent',
    options: [MessageFormatOption_1.default, LinkPreviewOption_1.default, QuickSuggestionsOption_1.default],
};
exports.default = messageContentSubcategory;
//# sourceMappingURL=messageContentSubcategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/messageContentSubcategory.js
// module id = 5130
// module chunks = 2